import {DataSourceFilter} from './data-source.filter';
import { Injectable } from "@angular/core";

@Injectable()
export class RatingFilter extends DataSourceFilter {
    public onFilterApplied(data: any, selectedRatings: string[]): boolean {
        return selectedRatings.includes(data.rating);
    }

    public identifier(): string {
        return 'RatingFilter';
    }
}
